import { takeEvery, put, delay, select, call } from "redux-saga/effects";

import { appInstance, davInstance, virtInstance } from "axios-config";
import * as types from "./types";
import {
  decodeHandler,
  decryptData,
  waitForConnection,
  decompressionAlgorithm,
  compareVersions
} from "utils";
import * as actions from "store/actions";
import { config } from "config";
import { CONTENT } from "consts";
import { showNotificationWithTimeout } from "store/actions";
import { NOTIFICATION_STATUS } from "App/componentsConfig";
import { NOTIFICATIONS, MEMORY_PLANS } from "../../../consts";
import { disableRPCconnectionstatus } from "App/Virtualization/ducks";

export function* initiateBackup(params) {
  yield takeEvery(types.INITIATE_BACKUP, action => {
    const req = {
      action: "startCloudBackup",
      data: { clientUUID: action.clientUUID }
    };

    waitForConnection(params.wsConnection, req, 1000);
  });
}

export function* initiateStopBackup(params) {
  yield takeEvery(types.INITIATE_STOP_BACKUP, action => {
    const req = {
      action: "stopCloudBackup",
      data: { clientUUID: action.clientUUID }
    };

    waitForConnection(params.wsConnection, req, 1000);
  });
}

export function* initiatePauseBackup(params) {
  yield takeEvery(types.INITIATE_PAUSE_BACKUP, action => {
    const req = {
      action: "pauseCloudBackup",
      data: { clientUUID: action.clientUUID }
    };

    waitForConnection(params.wsConnection, req, 1000);
  });
}

export function* initiateResumeBackup(params) {
  yield takeEvery(types.INITIATE_RESUME_BACKUP, action => {
    const req = {
      action: "resumeCloudBackup",
      data: { clientUUID: action.clientUUID }
    };

    waitForConnection(params.wsConnection, req, 1000);
  });
}

export function* fetchClientsStart() {
  try {
    const response = yield appInstance.get("/backup/list");

    yield put(actions.fetchClientsSuccess(response.data));
  } catch (error) {
    console.log(error);
  }
}

export function* downloadClientSetupStart(params) {
  try {
    let file_path =
      config.API_URL +
      (params.client ? "/" + params.client : "") +
      "/static/clientSetup/" +
      (params.origin === "360" || localStorage.getItem("origin") === "360"
        ? "IDriveMirror_thin"
        : params.client
        ? "IBackupMirror_full"
        : "IDriveMirror_full") +
      "?loginId=" +
      decryptData(localStorage.getItem("mirrorId")) +
      "&token=" +
      localStorage.getItem("token");
    const a = document.createElement("A");

    a.href = file_path;
    a.download = file_path.substr(file_path.lastIndexOf("/") + 1);

    yield document.body.appendChild(a);
    // The blank screen issue in mozilla firefox - NS_BINDING_ABORTED - #802
    if (window.browserName === "firefox") yield delay(5000);
    yield a.click();
    yield document.body.removeChild(a);
    yield delay(2000);
    yield put(actions.downloadClientSetupComplete());
  } catch (error) {
    console.log(error);
    yield put(actions.downloadClientSetupComplete());
  }
}

export function* initiateStopRestore(params) {
  yield takeEvery(types.INITIATE_STOP_RESTORE, action => {
    const req = {
      action: "cancelRestore",
      data: { clientUUID: action.clientUUID }
    };

    waitForConnection(params.wsConnection, req, 1000);
  });
}

export function* fetchClientStatusStart(action) {
  try {
    const response = yield appInstance.get("/backup/list/" + action.clientUUID);

    yield put(actions.fetchClientStatusSuccess(response.data, action.select));
  } catch (error) {
    console.log(error);
  }
}

export function* fetchClientVersionInfoStart(action) {
  try {
    const response = yield davInstance.get(
      "/appversion/getAppVersionAndSetup",
      {
        params: {
          product_name: CONTENT.productName[config.APP_INSTANCE]
        }
      }
    );

    if (response.status === 200)
      yield put(actions.fetchClientVersionInfoSuccess(response.data));
  } catch (error) {
    console.log(error);
  }
}

export function* fetchDeploymentTokenStart(action) {
  try {
    if (
      localStorage.getItem("dToken")
      // &&
      // JSON.parse(localStorage.getItem("dToken")).time + 3600000 > Date.now()
    ) {
      yield put(
        actions.fetchDeploymentTokenSuccess(
          JSON.parse(localStorage.getItem("dToken")).token
        )
      );
    } else {
      const response = yield davInstance.post("/token/deploymentmsi", null);
      if (response.data.code === 200) {
        const dToken = {
          token: response.data.message.token,
          time: Date.now()
        };
        localStorage.setItem("dToken", JSON.stringify(dToken));
        yield put(
          actions.fetchDeploymentTokenSuccess(response.data.message.token)
        );
      }
    }
  } catch (error) {
    console.log(error);
  }
}

export function* downloadClientMSIStart() {
  try {
    let file_path =
      config.API_URL +
      "/static/clientMsi?loginId=" +
      decryptData(localStorage.getItem("mirrorId")) +
      "&token=" +
      JSON.parse(localStorage.getItem("dToken")).token;
    const a = document.createElement("A");

    a.href = file_path;
    a.download = file_path.substr(file_path.lastIndexOf("/") + 1);

    yield document.body.appendChild(a);
    // The blank screen issue in mozilla firefox - NS_BINDING_ABORTED - #802
    if (window.browserName === "firefox") yield delay(5000);
    yield a.click();
    yield document.body.removeChild(a);
    yield delay(2000);
    yield put(actions.downloadClientMSIComplete());
  } catch (error) {
    console.log(error);
    yield put(actions.downloadClientMSIComplete());
  }
}

export function* fetchGroupsStart() {
  try {
    console.log("fetch groups call initiated");
    const response = yield appInstance.get("/groups/all", {
      responseType: "arraybuffer",
      "Accept-Encoding": "gzip",
      decompress: true
    });
    yield put(actions.fetchGroupsSuccess(response.data));
    if (response.status === 200) {
      if (
        decompressionAlgorithm(response.data).findIndex(
          group => group.groupId === 0 && group.clients_count !== 0
        ) >= 0
      ) {
        yield put(actions.fetchVirtUserInfoStart());
        yield put(actions.fetchVMsListStart());
      }
    }
  } catch (error) {
    console.log(error);
  }
}

export function* addClientsToGroupStart(action) {
  try {
    const response = yield appInstance.put(
      "/groups/update?op=add",
      action.data
    );
    if (response.status === 200) {
      yield put(actions.addClientsToGroupSuccess(action.data));
      // yield fetchGroupsStart();
      yield put(
        showNotificationWithTimeout("dashboard", {
          status: NOTIFICATION_STATUS.success.name,
          msg: NOTIFICATIONS.dashboardGroups.addClientsToGroup.success
        })
      );
    } else {
      yield put(
        showNotificationWithTimeout("dashboard", {
          status: NOTIFICATION_STATUS.failure.name,
          msg: NOTIFICATIONS.dashboardGroups.addClientsToGroup.failure
        })
      );
    }
  } catch (error) {
    console.log(error);
  }
}

export function* deleteDashboardGroupStart(action) {
  try {
    const response = yield appInstance.delete("/groups/settings", {
      data: { groupIDs: action.data.groupIDs }
    });
    if (response.status === 200) {
      yield put(actions.deleteDashboardGroupSuccess(action.data));
      yield put(
        showNotificationWithTimeout(action.data.position, {
          status: NOTIFICATION_STATUS.success.name,
          msg: NOTIFICATIONS.dashboardGroups.deleteGroup.success
        })
      );
    } else {
      yield put(
        showNotificationWithTimeout(action.data.position, {
          status: NOTIFICATION_STATUS.failure.name,
          msg: NOTIFICATIONS.dashboardGroups.deleteGroup.failure
        })
      );
    }
  } catch (error) {
    console.log(error);
  }
}

export function* renameDashboardGroupNameStart(action) {
  try {
    const response = yield appInstance.put("/groups/settings", {
      groupID: action.data.groupID,
      groupName: action.data.groupName
    });
    if (response.status === 200) {
      yield put(actions.renameDashboardGroupNameSuccess(action.data));
      yield put(
        showNotificationWithTimeout(action.data.position, {
          status: NOTIFICATION_STATUS.success.name,
          msg: NOTIFICATIONS.dashboardGroups.renameGroupName.success
        })
      );
    } else {
      yield put(actions.renameDashboardGroupNameFailure());
      yield put(
        showNotificationWithTimeout(action.data.position, {
          status: NOTIFICATION_STATUS.failure.name,
          msg: NOTIFICATIONS.dashboardGroups.renameGroupName.failure
        })
      );
    }
  } catch (error) {
    console.log(error);
  }
}

export function* createNewGroupDashboardStart(action) {
  try {
    const response = yield appInstance.post("/groups/settings", {
      groupName: action.data.groupName
    });

    if (response.status === 200) {
      yield put(actions.createNewGroupDashboardSuccess(response.data));
      yield put(
        showNotificationWithTimeout(action.data.position, {
          status: NOTIFICATION_STATUS.success.name,
          msg: `Device group '${decodeHandler(
            action.data.groupName
          )}' has been created successfully`
        })
      );
    } else {
      yield actions.createNewGroupDashboardFailure(response.data);
      yield put(
        showNotificationWithTimeout(action.data.position, {
          status: NOTIFICATION_STATUS.failure.name,
          msg: NOTIFICATIONS.dashboardGroups.createNewGroup.failure
        })
      );
    }
  } catch (error) {
    console.log(error);
  }
}

export function* removeClientsFromGroupStart(action) {
  try {
    const response = yield appInstance.put(
      "/groups/update?op=del",
      action.data
    );
    if (response.status === 200) {
      yield put(actions.removeClientsFromGroupSuccess(action.data));
      yield put(
        showNotificationWithTimeout("dashboard", {
          status: NOTIFICATION_STATUS.success.name,
          msg: NOTIFICATIONS.dashboardGroups.removeMachineFromGroup.success
        })
      );
    } else {
      yield put(
        showNotificationWithTimeout("dashboard", {
          status: NOTIFICATION_STATUS.success.name,
          msg: NOTIFICATIONS.dashboardGroups.removeMachineFromGroup.failure
        })
      );
    }
  } catch (error) {
    console.log(error);
  }
}

export function* fetchClientServerIPAddressStart(action) {
  try {
    const response = yield appInstance.get("/backup/clientServerIPAddress", {
      params: {
        clientUUID: action.client.clientUUID
      }
    });
    if (response.status === 200) {
      yield put(
        actions.fetchClientServerIPAddressResponse(action.client, response.data)
      );
    } else {
      yield put(actions.fetchClientServerIPAddressResponse(action.client, ""));
    }
  } catch (error) {
    console.log(error);
  }
}

export function* createVirtualizationAccountStart(action) {
  try {
    const response = yield virtInstance.post("/account/", {
      username: decryptData(localStorage.getItem("mirrorId")),
      memory_plan: action.data ? action.data : MEMORY_PLANS[0]
    });
    if (response.status === 200) {
      console.log("virtualization account created successfully");
    }
  } catch (error) {
    console.log(error);
  }
}

export function* controlVMFromDashboardStart(action) {
  try {
    const data = { ...action.data };
    delete data.clientUUID;
    const response = yield virtInstance.post("/control_vm/", action.data);
    if (response.status === 200) {
      let notifMsg = decodeHandler(response.data).replace(
        "Virtual Machine",
        "Virtual instance"
      );
      // yield put(
      //   showNotificationWithTimeout("dashboard", {
      //     status: NOTIFICATION_STATUS.success.name,
      //     msg: decodeHandler(response.data).replace(
      //       "Virtual Machine",
      //       "Virtual instance"
      //     )
      //   })
      // );
      //checking version and adding the list for RPC console boot progress
      try {
        const vmsList = yield select(state => state.virtualization.vmsList);
        const vm = vmsList.find(
          val => val.client_uuid === action.data.client_uuid
        );
        if (
          vm?.boot_params.enable === "yes" ||
          vm?.network?.source === "disconnected" ||
          !vm?.rpc_mac_id
        ) {
          yield put(
            showNotificationWithTimeout("dashboard", {
              status: NOTIFICATION_STATUS.success.name,
              msg: decodeHandler(response.data).replace(
                "Virtual Machine",
                "Virtual instance"
              )
            })
          );
        } else {
          if (
            action.data.action === "power_off" ||
            action.data.action === "reboot"
          ) {
            yield call(disableRPCconnectionstatus, action.data.client_uuid);
            yield put(
              actions.logoutSingleVirtInstances(action.data.client_uuid)
            );
            yield delay(2000);
          }
          if (
            action.data.action === "power_on" ||
            action.data.action === "reboot"
          ) {
            yield put(
              actions.setRPCConsoleBootProgress(
                action.data.client_uuid,
                notifMsg,
                false
              )
            );
          } else {
            yield put(
              showNotificationWithTimeout("dashboard", {
                status: NOTIFICATION_STATUS.success.name,
                msg: notifMsg
              })
            );
          }
        }
      } catch (error) {
        console.log(error);
      }
      yield put(actions.controlVMFromDashboardSuccess(action.data));
      yield put(actions.controlVMSuccess(response.data, action.data));
    } else {
      yield put(actions.controlVMFromDashboardFailure(action.data));
      yield put(actions.controlVMFailure("", action.data));
      yield put(
        showNotificationWithTimeout("dashboard", {
          status: NOTIFICATION_STATUS.failure.name,
          msg: NOTIFICATIONS.virtualization.controlVM.failure
        })
      );
    }
  } catch (error) {
    console.log(error);
  }
}
